import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  private readonly agencyTypeBehavior = new BehaviorSubject<boolean>(false);
  agencyTypeObservable = this.agencyTypeBehavior.asObservable();

  constructor() { }

  setLSItem(itemKey:string, itemValue:string){
    sessionStorage.setItem(itemKey, itemValue);
  }

  getLSItem(itemKey:string) : string{
    return sessionStorage.getItem(itemKey);
  }

  removeLSItem(itemKey:string){
    sessionStorage.removeItem(itemKey)
  }

  changueAgencyType(changue:boolean){
    this.agencyTypeBehavior.next(changue)
  }
}
